<template>

    <div>
    <header class="header">
        <nav class="gnav">
            <div class="gnav-inner">
                <p class="gnav-sub-ttl is-first">レイヤー</p>
                <ul class="gnav-layer">
                    <li><a href="#" :class="activateMenu('shape1')" @click.prevent="changeShapeType('shape1')">洪水浸水想定区域</a></li>
                    <li><a href="#" :class="activateMenu('shape2')" @click.prevent="changeShapeType('shape2')">土砂災害警戒区域</a></li>
                    <li><a href="#" :class="activateMenu('shape3')" @click.prevent="changeShapeType('shape3')">土砂災害危険箇所</a></li>
                </ul>

                <p class="gnav-sub-ttl">スポット</p>

                <div class="gnav-list-ac">
                    <p class="f-check"><input type="checkbox" id="cb01-00" v-model="isRenderShizenSaigaiMarker" @click="clickShizenSaigaiCheckBox()"><label for="cb01-00"><span class="icon-f icon-denshouhi"></span>自然災害伝承碑</label></p>
                    <p class="f-check"><input type="checkbox" id="cb04-00"  v-model="isRenderTameikeMarker" @click="clickTameikeCheckBox()"><label for="cb04-00"><span class="icon-f icon-tameike"></span>ため池</label></p>
                </div>
                
                <div class="g-hanrei">
                    <p class="gnav-sub-ttl">洪水浸水想定区域の凡例</p>
                    <ul class="hanrei-list">
                        <li><span class="color-golden-yellow"></span>0～0.5ｍ未満</li>
                        <li><span class="color-cyan"></span>0.5～1.0ｍ未満</li>
                        <li><span class="color-orange"></span>1.0～2.0ｍ未満</li>
                        <li><span class="color-carmine"></span>2.0～5.0ｍ未満</li>
                        <li><span class="color-deep-purple"></span>5.0ｍ以上</li>
                    </ul>
                </div>
            </div>
        </nav>

        <div class="gnav-toggle" id="js-hamburger" @click="toggleMenu()">
            <span class="gnav-toggle-line gnav-toggle-line--1"></span>
            <span class="gnav-toggle-line gnav-toggle-line--2"></span>
            <span class="gnav-toggle-line gnav-toggle-line--3"></span>
            <span class="gnav-txt">メニュー</span>
        </div>

        <div class="header-title">
            <h1>居住地の安全確認</h1>
        </div>

        <div class="h-home">
            <a href="/">
                <div class="h-home-inner">
                    <span class="h-home-icon"></span><span class="h-home-txt">ホーム</span>
                </div>
            </a>
        </div>
        <div class="black-bg" id="js-black-bg"></div>
    </header>

    <main class="main">
        <div class="main-inner">
            <!-- Map Area -->
            <div id="map"></div>
            <!-- /Map Area -->
        </div>
    </main>

    </div>
</template>

<script>
    import env from '../../config/env.var'
    import L from 'leaflet'

    export default {
        name: 'MapA',
        components:{},
        data () {
            return{
                map: null,
                radius: 2000, // meter
                markerGroup: null,
                mapCircle: null,
                tfCircle: null,
                isRenderShizenSaigaiMarker: true,
                isRenderTameikeMarker: true,
                shizenSaigaiMarker: null,
                tameikeMarker: null,
            }
        },
        mounted () {
            this.drawMap()
            Promise.all([this.getShape(), this.getCsv()])
            .then(() => {
                this.renderShape()
            })
            Promise.all([this.getShizenSaigai()])
            .then(() => {
                this.renderShizenSaigai();
            });
            Promise.all([this.getTameike()])
            .then(() => {
                this.renderTameike();
            });

        },
        computed: {
            sharedState () {
                return this.$store.state
            },
            shape_type () {
                return this.sharedState.shape_type
            }
        },
        methods: {
            toggleMenu() {
                const body = document.body;
                body.classList.toggle('nav-open');
            },
            activateMenu(shapeType) {
              return this.sharedState.shape_type === shapeType ? 'is-active': ''  
            },
            drawMap () {
                // タイルの設定
                const osmtile = L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
                    zIndex: 1,
                    attribution: '&copy; <a href="//osm.org/copyright">OpenStreetMap</a> contributors'
                })
                const gsistdtile = L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
                    zIndex: 1,
                    attribution: "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>"
                })    
                const pale = L.tileLayer('//cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png', {
                    zIndex: 1,
                    attribution: '&copy; <a href="https://maps.gsi.go.jp/development/ichiran.html" target=\'_blank\'>地理院タイル</a>'
                })
                // マップの初期化
                const map = L.map('map', { 
                    center: [34.633626, 133.710630],
                    zoom: 14,
                    layers: [pale],
                    zoomControl: false,
                    minZoom: 6,
                    maxZoom: 17,
                    gestureHandling: true,
                    preferCanvas: true,
                    scrollWheelZoom: false
                })
                L.control.zoom({ position: 'bottomright' }).addTo(map)
                const mapObj = document.getElementById('map')
                // フォーカスしたらズームできるようになる
                mapObj.addEventListener("focus", () => {map.scrollWheelZoom.enable()});
                // フォーカスはずれたらズームできなくする
                mapObj.addEventListener("blur", () => {map.scrollWheelZoom.disable()});

                // デバッグ用に縮尺表示
                L.control.scale({imperial:false}).addTo(map)

                L.control.layers({
                  "OpenStreetMap": osmtile,
                  "国土地理院 - 淡色": pale,
                  "国土地理院 - 標準地図": gsistdtile,
                }).addTo(map)

                this.map = map
                this.$store.commit('setMap', map)
            },
            async removeLayer (shape_type) {
                await this.$store.commit('removeLayer', this.sharedState.layers[shape_type])
            },
            setColor (features) {
                // csvのデータからshapeの色分け
                // const KEY_CODE = features.properties.KEY_CODE
                // let popLevel = 0;
                // const info = this.sharedState.csv[this.sharedState.shape_type][KEY_CODE]
                // if (info) {
                //     for (const level in env.THRESHOLD) {
                //         if (info.value >= env.THRESHOLD[level].value) popLevel = level
                //     }
                // }
                // return env.THRESHOLD[popLevel].color
                switch (this.sharedState.shape_type) {
                    case 'shape1':
                        return env.THRESHOLD[features.properties.A31_001]
                    case 'shape2':
                        return env.DOSYA_KEIKAI
                    case 'shape3':
                        return env.DOSYA_KIKEN
                    default:
                        return env.THRESHOLD[features.properties.A31_001]
                }

            },
            async getShape () {
                await this.$store.dispatch('getShape')
            },
            async getCsv () {
                await this.$store.dispatch('getCsv')
            },
            async getShizenSaigai() {
                await this.$store.dispatch('getShizenSaigai')
            },
            async getTameike() {
                await this.$store.dispatch('getTameike')
            },
            setShapePopup (features, layer) {
                switch (this.shape_type) {
                    case 'shape1':
                        //洪水浸水想定区域図
                        const info = env.SHINSUI_LEVEL[features.properties.A31_001]  //eslint-disable-line
                        if (info) {
                            layer.bindPopup(`
                                <div>想定浸水深：${info.meter}</div><br/>
                            `)
                        } else {
                            layer.bindPopup(`データがありません`)
                        }
                        break;
                }
            },
            renderShape () {
                // var prevLayerClicked = null;
                const geo = L.geoJSON(this.sharedState.shape[this.sharedState.shape_type], {
                    style:(features) => {
                        // console.log(features) //eslint-disable-line
                        return {
                            fillColor: this.setColor(features),
                            color: 'grey',
                            // color: '#00a795',
                            weight: 0.5,
                            fillOpacity: .5
                        }
                    },
                    getColor:(d) => {
                        return d < 1 ? '#173e34' : '#e1cb7f';
                    },
                    onEachFeature: (features, layer) => {
                        // const KEY_CODE = features.properties.KEY_CODE
                        // const info = this.sharedState.csv[this.sharedState.shape_type][KEY_CODE] 
                        // console.log(features)  //eslint-disable-line

                        const DEFAULT_BORDER_STYLE = {
                            color: 'grey',
                            weight: 0.5,
                        }

                        const FOCUSED_BORDER_STYLE = {
                            color: 'red',
                            weight: 1.5,
                        }

                        this.setShapePopup(features, layer)
                        layer.on({
                                mouseover: function()
                                {
                                    if( ! layer.isPopupOpen()){
                                        layer.setStyle(FOCUSED_BORDER_STYLE)
                                    }
                                },
                                mouseout: () =>
                                {
                                    if( ! layer.isPopupOpen()){
                                        layer.setStyle(DEFAULT_BORDER_STYLE)
                                    }
                                },
                                popupopen: function()
                                {
                                    layer.setStyle(FOCUSED_BORDER_STYLE)
                                },
                                popupclose: function()
                                {
                                    layer.setStyle(DEFAULT_BORDER_STYLE)
                                }

                            })
                    }, 
                    renderer: L.svg()
                })
                this.$store.commit('addLayer', geo)  

            },
            changeShapeType (shape_type) {
                this.$store.commit('setShapeType', shape_type)
            },
            changeShape (newval, oldval) {
                if (this.sharedState.layers[newval] == null) {
                    Promise.all([this.getShape(), this.getCsv()])
                    .then(() => {
                        this.removeLayer(oldval)
                        this.renderShape()
                    })
                } else {
                    this.removeLayer(oldval)
                    this.renderShape()
                }
            },
            renderShizenSaigai(){
                
                const iconUrl = env.markerCategory2Img['自然災害伝承碑']
                
                let markerGroup = [] 
                for(var i = 0; i < this.sharedState.shizen_saigai.length; i++){
                    var popup1 = L.popup({
                        keepInView : true,
                        minWidth : 500,
                        autoPanPadding: L.point(0, 70) // ヘッダーメニューの高さ分paddingを設定
                    }).setContent(
                        "<h1 class='modal-title pb-xs'>"+this.sharedState.shizen_saigai[i]['碑名称']+"</h1>"+
                        "<div class='pb-sm'>"+
                        "<dl class='dl-list is-modal is-first'>"+"<dt>建立年</dt>"+"<dd>"+this.sharedState.shizen_saigai[i]['建立年(西暦)']+"</dd>"+"</dl>"+
                        "<dl class='dl-list is-modal'>"+"<dt>碑所在地</dt>"+"<dd>"+this.sharedState.shizen_saigai[i]['碑所在地']+"</dd>"+"</dl>"+
                        "<dl class='dl-list is-modal'>"+"<dt>伝承内容</dt>"+"<dd>"+this.sharedState.shizen_saigai[i]['伝承内容']+"</dd>"+"</dl>"+
                        "<dl class='dl-list is-modal'>"+"<dt>災害名称</dt>"+"<dd>"+this.sharedState.shizen_saigai[i]['災害名称']+"</dd>"+"</dl>"+
                        "<dl class='dl-list is-modal'>"+"<dt>災害発生年月日</dt>"+"<dd>"+this.sharedState.shizen_saigai[i]['災害発生年月日']+"</dd>"+"</dl>"+
                        "</div>"
                );

                    // specify popup options 
                    // customizing leaflet popup https://stackoverflow.com/questions/12606141/how-would-i-customise-the-look-and-feel-of-the-leaflet-popup
                    var customOptions =
                        {
                        // 'closeButton': false,
                        'closeOnClick': true,
                        'className' : 'popupCustom'
                        }
                    var markerIcon = L.icon({ iconUrl: iconUrl, iconRetinaUrl: iconUrl, iconSize: [35, 35], iconAnchor: [17, 17], popupAnchor: [0, -50] });
                    const mark = L.marker([this.sharedState.shizen_saigai[i]['緯度'],this.sharedState.shizen_saigai[i]['経度']], { icon:markerIcon }, { draggable: false }).bindPopup(popup1, customOptions).bindTooltip(this.sharedState.shizen_saigai[i]['碑名称']);
                    // this.$store.commit('addMarker', mark)
                    markerGroup.push(mark)
                }
                this.shizenSaigaiMarker = L.layerGroup(markerGroup).addTo(this.map)
            },
            renderTameike(){
                let markerGroup = []
                
                const iconUrl = env.markerCategory2Img['ため池']
                
                // specify popup options 
                    var customOptions =
                        {
                        // 'closeButton': false,
                        'closeOnClick': true,
                        'className' : 'popupCustom'
                        }
                for(var i = 0; i < this.sharedState.tameike.length; i++){
                    let url = "./static/files/tameike/"+this.sharedState.tameike[i]['画像データファイル名']
                    var popup1 = L.popup({
                        keepInView : true,
                        minWidth : 500,
                        autoPanPadding: L.point(0, 70) // ヘッダーメニューの高さ分paddingを設定
                    }).setContent(
                        "<h1 class='modal-title pb-xs'>"+this.sharedState.tameike[i]['名称']+"</h1>"+
                        "<div class='pb-sm'>"+
                        "</div>"+
                        "<div class='popup-btn'><a target='_blank' href='"+ url +"' class='c-btn c-btn-default c-btn-md'>ため池ハザードマップを見る</a></div>"
                    );
                    var markerIcon = L.icon({ iconUrl: iconUrl, iconRetinaUrl: iconUrl, iconSize: [35, 35], iconAnchor: [17, 17], popupAnchor: [0, -50] });
                    const mark = L.marker([this.sharedState.tameike[i]['緯度'],this.sharedState.tameike[i]['経度']], { icon:markerIcon }, { draggable: false }).bindPopup(popup1, customOptions).bindTooltip(this.sharedState.tameike[i]['名称']);
                    // this.$store.commit('addMarker', mark)
                    markerGroup.push(mark)
                }
                this.tameikeMarker = L.layerGroup(markerGroup).addTo(this.map)

            },
            clickShizenSaigaiCheckBox() {
                if (!this.isRenderShizenSaigaiMarker) {
                    this.$store.commit('addMarker', this.shizenSaigaiMarker)
                } else {
                    this.$store.commit('removeMarker', this.shizenSaigaiMarker)
                }
            },
            clickTameikeCheckBox() {
                if (!this.isRenderTameikeMarker) {
                    this.$store.commit('addMarker', this.tameikeMarker)
                } else {
                    this.$store.commit('removeMarker', this.tameikeMarker)
                }
            },
        },
        watch: {
            shape_type: function(newval, oldval) {
                this.changeShape(newval, oldval)
            },
        }
    }
</script>

<style>
    
/*
 * Leafletのレイヤーコントロールの位置調整
 * 参考 https://github.com/Leaflet/Leaflet/issues/4021
 */

.leaflet-control-container {
    display: block;
}

.leaflet-control-layers {
    left: 0px;
    top: 60px;
}

.leaflet-touch .leaflet-control-attribution {
    display: none;
}
    
</style>
